<template>
  <div class="rmk-rcd">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="all-lst">
        <div class="day-lst" v-for="(item, i) in dataList" :key="i">
          <div class="time">{{ item.name }}</div>
          <div class="item" v-for="(cld, i) in item.child" :key="i">
            <img :src="cld.img" alt="" />
            <div class="info">
              <div class="name">{{ cld.title }}</div>
              <p>点评内容：{{ cld.rmkContent }}</p>
              <div class="score">
                <span>{{ cld.score }}</span>
                <div
                  class="btn"
                  @click="
                    $router.push({
                      path: '/judge/remarkpage',
                      query: { id: cld.id, isRemark: 1 }
                    })
                  "
                >
                  详情
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getPageCommentRecord } from "@/utils/api/judge";
import { dateFormat } from "@/utils/tool";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      // 日期列表 用于对比日期，并储存到 dataList 中
      dayList: [],
      dataList: [
        // {
        //   time: "时间",
        //   child: [
        //     {
        //       img: "",
        //       title: "标题",
        //       score: 95,
        //       rmkContent: "点评内容"
        //     }
        //   ]
        // }
      ]
    };
  },
  methods: {
    onLoad() {
      this.page++;
      this.getRecordData(this.page === 1);
    },
    // 获取点评记录
    getRecordData(init = false) {
      this.loading = true;
      const p = {
        pageNo: this.page,
        pageSize: this.pageSize
      };
      if (init) {
        this.dayList = [];
        this.dataList = [];
      }
      getPageCommentRecord(p).then((res) => {
        if (res.success) {
          const allList = res.data.records;
          // 设置最外层日期
          const setDaylist = (list) => {
            return new Promise((res) => {
              let dayList = this.dataList;
              list.map((e, i) => {
                let d = dateFormat(e.addTimeRubbing, "YYYY-MM-DD");
                const td = dateFormat(Date.parse(new Date()), "YYYY-MM-DD");
                const has =
                  dayList.findIndex((e) => {
                    return e.val == d;
                  }) !== -1;
                if (!has) {
                  const diff = Date.parse(td) - Date.parse(d);
                  if (diff == 0) {
                    dayList.push({ name: "今天", val: d, child: [] });
                  } else if (diff <= 86400000) {
                    dayList.push({ name: "昨天", val: d, child: [] });
                  } else if (diff > 86400000 && diff <= 172800000) {
                    dayList.push({ name: "前天", val: d, child: [] });
                  } else {
                    dayList.push({ name: d, val: d, child: [] });
                  }
                }
                if (i === list.length - 1) {
                  res(dayList);
                }
              });
            });
          };
          // 设置以天为单位梳理评论列表
          setDaylist(allList).then((list) => {
            list.forEach((day) => {
              allList.forEach((item) => {
                if (day.val == dateFormat(item.addTimeRubbing, "YYYY-MM-DD")) {
                  day.child.push({
                    id: item.id,
                    img: item.imgs,
                    title: item.name,
                    score: item.fraction,
                    rmkContent: item.comment
                  });
                }
              });
            });
            this.dataList = list;
          });
          this.loading = false;
          if (this.page * this.pageSize >= res.data.total) {
            this.finished = true;
          }
        } else {
          this.loading = false;
          this.finished = true;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.rmk-rcd {
  width: 100%;
  height: 100%;
  max-width: 10rem;
  background-color: #fff;
  text-align: left;
  .all-lst {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    .day-lst {
      background-color: #fff;
      margin-bottom: 13px;
      .time {
        padding: 0 20px;
        height: 45px;
        font-size: 12px;
        color: #999999;
        line-height: 45px;
      }
      .item {
        margin: 0 20px;
        padding: 12px;
        display: flex;
        height: 104px;
        box-shadow: 0px 3px 6px rgba(5, 75, 27, 0.2);
        border-radius: 8px;
        margin-bottom: 15px;
        img {
          height: 80px;
          width: 80px;
          border-radius: 10px;
        }
        .info {
          margin-left: 20px;
          flex: 1;
          * {
            max-width: 200px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .name {
            line-height: 25px;
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }
          p {
            line-height: 24px;
            font-size: 12px;
            color: #666;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            line-height: 17px;
            margin-top: 4px;
          }
          .score {
            display: flex;
            justify-content: space-between;
            margin-top: 12px;
            align-items: center;
            max-width: unset;
            span {
              line-height: 24px;
              color: #fcc100;
              font-size: 16px;
              font-weight: bold;
              &::after {
                content: "分";
                font-size: 12px;
                font-weight: 100;
              }
            }

            .btn {
              width: 50px;
              height: 20px;
              border-radius: 10px;
              color: #6cdd8f;
              text-align: center;
              line-height: 20px;
              border: 1px solid #6cdd8f;
            }
          }
        }
      }
    }
  }
}
</style>
